import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { combineLatest, map } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export const isLoggedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService); // Inyecta el servicio de autenticación
  const router = inject(Router); // Inyecta el Router para redirecciones

  return combineLatest([authService.authChecked$, authService.isLogged$]).pipe(
    filter(([authChecked]) => authChecked),
    take(1),
    map(([, isLoggedIn]) => {
      if (isLoggedIn) {
        router.navigate(['/admin/home']); // Redirige al home si está autenticado
        return false;
      }
      return true; // Permite el acceso si no está autenticado
    })
  );
};
